import React, { useEffect, useState } from "react"
import Modal from "../index"
import Button from "../../Form/Button"
import Checkbox from "../../Form/Checkbox"
import FormGroupInline from "../../Form/FormGroupInline"
import Input from "../../Form/Input"
import styles from "./modalOutboundCampaign.module.css"

const toNumber = (value = 0) => Number(`${value}`.replace(",", ".")) || 0
const normalizeMoneyValue = (value = 0) => Number(value || 0).toFixed(2)
const normalizeSettings = (settings = {}) => ({
    enabled: Boolean(settings?.enabled),
    amount_brl: normalizeMoneyValue(settings?.amount_brl),
    inboxes: Array.isArray(settings?.inboxes)
        ? settings.inboxes.map(inbox => ({ ...inbox, amount_brl: normalizeMoneyValue(inbox.amount_brl) }))
        : []
})

const LimitSettings = ({ settings = {}, inboxes = [], canUpdate = false, editable = true, isSaving = false, wrapModal = true, closeModal = () => { }, onCancel = () => { }, onSubmit = () => { } }) => {
    const [localSettings, setLocalSettings] = useState(normalizeSettings(settings))
    const fieldsEditable = canUpdate && editable && !isSaving

    useEffect(() => {
        setLocalSettings(normalizeSettings(settings))
    }, [settings])

    const getInboxLimit = (inboxId) => {
        return localSettings.inboxes.find(inbox => inbox.inbox_id === inboxId) || {
            inbox_id: inboxId,
            enabled: false,
            amount_brl: "0.00",
        }
    }

    const updateInboxLimit = (inboxId, changes) => {
        setLocalSettings(previousValue => {
            const exists = previousValue.inboxes.some(inbox => inbox.inbox_id === inboxId)
            const nextInboxes = exists
                ? previousValue.inboxes.map(inbox => inbox.inbox_id === inboxId ? { ...inbox, ...changes } : inbox)
                : [...previousValue.inboxes, { inbox_id: inboxId, enabled: false, amount_brl: "0.00", ...changes }]

            return { ...previousValue, inboxes: nextInboxes }
        })
    }

    const handleSubmit = () => {
        onSubmit({
            enabled: Boolean(localSettings.enabled),
            amount_brl: toNumber(localSettings.amount_brl),
            inboxes: localSettings.inboxes.map(inbox => ({
                inbox_id: inbox.inbox_id,
                enabled: Boolean(inbox.enabled),
                amount_brl: toNumber(inbox.amount_brl),
            }))
        })
    }

    const handleCancel = () => {
        setLocalSettings(normalizeSettings(settings))
        onCancel()
    }

    const content = (
        <div className={styles.body}>
                <button type="button" className={styles.checkboxOption} disabled={!fieldsEditable} onClick={() => setLocalSettings(previousValue => ({ ...previousValue, enabled: !previousValue.enabled }))}>
                    <Checkbox checked={localSettings.enabled} pink={true} />
                    <div className={styles.checkboxText}>
                        <strong>Limite mensal geral</strong>
                        <span>Quando ativo, nenhuma campanha poderá fazer o custo mensal estimado ultrapassar o valor definido. Deixe desativado para não ter limite.</span>
                    </div>
                </button>
                {localSettings.enabled &&
                    <div className={styles.limitValueRow}>
                        <span>Valor mensal geral</span>
                        <Input type="currency" value={localSettings.amount_brl} disabled={!fieldsEditable} onChange={(e) => setLocalSettings(previousValue => ({ ...previousValue, amount_brl: e.target.value }))} />
                    </div>
                }
                <div className={styles.limitSettingsList}>
                    <div className={styles.limitSettingsHeader}>
                        <strong>Limites por caixa de entrada</strong>
                        <span>Opcional. Quando ativo, o limite da caixa substitui o limite geral para campanhas daquela caixa.</span>
                    </div>
                    {inboxes.map(inbox => {
                        const limit = getInboxLimit(inbox.id)

                        return (
                            <div key={inbox.id} className={styles.limitInboxRow}>
                                <button type="button" disabled={!fieldsEditable} onClick={() => updateInboxLimit(inbox.id, { enabled: !limit.enabled })}>
                                    <Checkbox checked={limit.enabled} pink={true} />
                                    <span>{inbox.value}</span>
                                </button>
                                <Input type="currency" value={limit.amount_brl} disabled={!fieldsEditable || !limit.enabled} onChange={(e) => updateInboxLimit(inbox.id, { amount_brl: e.target.value })} />
                            </div>
                        )
                    })}
                </div>
                {!canUpdate &&
                    <div className={styles.confirmationNotice}>
                        Você não possui permissão para alterar estes limites. Fale com o responsável pela conta caso precise ajustar a configuração.
                    </div>
                }
                {canUpdate && editable &&
                    <FormGroupInline>
                        <Button variant="primary" disabled={isSaving} onClick={handleSubmit}>Salvar</Button>
                        <Button variant="secondary" disabled={isSaving} onClick={handleCancel}>Cancelar</Button>
                    </FormGroupInline>
                }
            </div>
    )

    if (!wrapModal) {
        return content
    }

    return (
        <Modal
            title="Limites de campanhas"
            description="Controle o custo mensal estimado dos disparos por WhatsApp API."
            closeModal={closeModal}
            heightFitContent={true}
        >
            {content}
        </Modal>
    )
}

export default LimitSettings
